<template>
  <div class="bg-white rounded-xl border border-gray-200 p-5">
    <div class="flex items-center justify-between mb-4 flex-wrap gap-2">
      <h3 class="text-sm font-semibold text-gray-700">{{ title }}</h3>
      <slot name="controls" />
    </div>

    <!-- Loading -->
    <div v-if="loading" class="flex items-center justify-center h-64">
      <div class="w-8 h-8 border-3 border-gray-200 border-t-primary rounded-full animate-spin"></div>
    </div>

    <!-- Error -->
    <div v-else-if="error" class="flex flex-col items-center justify-center h-64 gap-2">
      <span class="text-sm text-red-500">{{ error }}</span>
      <button @click="$emit('retry')" class="text-xs text-primary font-medium hover:underline">Reessayer</button>
    </div>

    <!-- Chart content -->
    <div v-else class="h-64">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'DashboardChartWrapper',
  props: {
    title: String,
    loading: Boolean,
    error: String
  },
  emits: ['retry']
}
</script>
